import * as React from 'react';
import { render } from 'react-dom';
import RootApp from '@/apps/root.app';

render(<RootApp />, document.getElementById('root'));
